import $ from 'jquery/src/jquery';
import {isInViewport} from "../functions";

export default () => {
    const nodeSelectors = {
        container: '[js-site-header="container"]',
        stayHiddenEl: '[js-site-header="stay-hidden-if-el-visible"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        initHeader()
    }

    function initHeader() {
        let scrollDirectionDown = true

        window.addEventListener('scroll', function() {
            if ( $('body').hasClass('admin-bar') && window.scrollY > 46 ) {
                $('body').addClass('admin-bar-is-active-but-not-in-view')
            } else {
                $('body').removeClass('admin-bar-is-active-but-not-in-view')
            }

            /**
             * Hide/Show header on scroll
             * If user scrolls down header will be hidden or if user scrolls up header will be visible
             */
            scrollDirectionDown = this.oldScroll <= this.scrollY
            this.oldScroll = this.scrollY

            if ( scrollDirectionDown ) {
                // Scrolling down
                if(
                    window.scrollY > 100
                    &&
                    !$(nodeSelectors.container).hasClass('nav-is-active')
                )
                    hide()
            } else if( !isInViewport($(nodeSelectors.stayHiddenEl)) ) {
                show()
            }
            /**
             * Hide/Show header on scroll END
             */
        })
    }

    function show() {
        document.querySelector(nodeSelectors.container).style.top = '0px'
    }

    function hide() {
        document.querySelector(nodeSelectors.container).style.top = - document.querySelector(nodeSelectors.container).offsetHeight + 'px'
    }

    return Object.freeze({
        init,
        nodeSelectors,
        show,
        hide
    })
}